module.exports = __webpack_public_path__ + "static/img/speed.7a0d1dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/speed.png
// module id = uDCC
// module chunks = 1